import { render } from "./pause.vue?vue&type=template&id=d0c0bdf8"
import script from "./pause.vue?vue&type=script&lang=js"
export * from "./pause.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__